import React from 'react'
import { TechnicianDto } from '../../generated';

import { EventInput, EventApi } from '@fullcalendar/core'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timegridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import itLocale from '@fullcalendar/core/locales/it';

import InterventiReportStore from "../InterventiReportStore"
import TechiniciansStore from "../../technicians/TechiniciansStore"
import InterventiActions from '../InterventiActions';
import { CustomerData } from '../../customers/components/CustomerData';
import DatesHelper from '../../common/datesHelper';
import Period from '../../common/period';
import TechnicianViewer from '../../technicians/components/TechnicianViewer';
import { isMobile } from '../../common/featurechecks';
import { addressDescription } from '../../customers/components/customerForm';
import { TechniciansFilter } from '../../technicians/components/TechniciansFilter';
import { Loading } from '../../common/components/loading';
import { RouteComponentProps } from 'react-router';
import { links } from '../../routes';
import OpenModalButton from '../../common/components/openModalButton';
import SyncCalendarComponent from './SyncCalendarComponent';
import { openModal } from '../../common/components/Modal';
import { ImpiantoAddressDescription } from '../../impianti/components/impiantoLightData';

interface State {
    technicians: TechnicianDto[] | null;
}


export default (props: RouteComponentProps) => {
    const DayComponent: React.FC<{ event: EventApi }> = ({ event }) => {
        const intervento = InterventiReportStore.get(event.id);
        const technicians = TechiniciansStore.getall();
        if (!intervento || !technicians)
            return null;
        const backgroundColor = technicians.find(t => t.id === intervento.idTechnician)?.color;
        return <CustomerData
            id={intervento.idCliente}
            template={customer =>
                <div className="d-flex flex-wrap justify-content-between h-100" style={{ backgroundColor }}>
                    <div>{event.start != null && DatesHelper.getTimeString(event.start)} - {event.end != null && DatesHelper.getTimeString(event.end)}</div>
                    <div>{`${customer.responsabile || `${customer.cognomeProprietario} ${customer.nomeProprietario}`}`}</div>
                    <div style={{ whiteSpace: "normal" }}>
                        {intervento.idImpianto
                            && <ImpiantoAddressDescription
                                customer={customer}
                                idImpianto={intervento.idImpianto}
                            /> ||
                            <div>{addressDescription(customer)} {customer.piano && <span className="ms-3">Piano: <strong>{customer.piano}</strong></span>}</div>}
                    </div>
                    <div>
                        <TechnicianViewer
                            id={intervento.idTechnician}
                            template={technician => <><strong>{technician.firstName} {technician.lastName}</strong></>}
                        />
                    </div>
                </div>
            } />
    };

    const calendar = React.useRef<FullCalendar>(null);
    const [state, setState] = React.useState<State>({ technicians: null })

    const allTechnicians = TechiniciansStore.useAll();
    if (allTechnicians == null)
        return <Loading />

    return (
        <div className="card">
            <div className="card-header bg-theme d-flex align-items-center">
                <div className="flex-fill">
                    <h3 className="text-white mb-0">Calendario Interventi</h3>
                </div>
            </div>
            <div className="card-body">
                <div className='row'>
                    <div className='col-12 col-lg-11'>
                        <TechniciansFilter
                            // label='Filtra agenda tecnici'
                            selected={state.technicians || allTechnicians}
                            onChange={technicians => setState({ ...state, technicians })}
                        />
                    </div>
                    <div className='col-12 col-lg-1 d-flex flex-column justify-content-center'>
                        <OpenModalButton
                            header={<h3 className="bg-theme text-white">Sicronizza agenda tecnici</h3>}
                            className='btn btn-secondary align-items-end pulse'
                            modalContent={<SyncCalendarComponent allTechnicians={allTechnicians} />}>
                            <i className='fas fa-cog' /> Sincronizza agenda con Google, ICloud, Outlook
                        </OpenModalButton>
                    </div>
                </div>
                <FullCalendar
                    ref={calendar}
                    themeSystem='stadard'
                    height="auto"
                    locale={itLocale}
                    selectable
                    editable
                    initialView={isMobile() ? "timeGridDay" : "timeGridWeek"}
                    plugins={[dayGridPlugin, timegridPlugin, interactionPlugin]}
                    slotMinTime="06:00:00"
                    slotMaxTime="21:00:00"
                    businessHours={{
                        daysOfWeek: [1, 2, 3, 4, 5],
                        startTime: '06:00',
                        endTime: '21:00',
                    }}
                    headerToolbar={{
                        left: 'dayGridMonth,timeGridWeek,timeGridDay',
                        center: 'title',
                        right: 'custom1 prevYear,prev,next,nextYear',
                    }}
                    customButtons={{
                        custom1: {
                            text: '+Intervento',
                            click: () => {
                                props.history.push(links.interventoNew())
                            }
                        },
                    }}
                    select={async event => {
                        openModal(modal => <div className='d-flex flex-column'>
                            <div>Vuoi creare un intervento {DatesHelper.getReadableDateTimeString(event.start)} {DatesHelper.getReadableDateTimeString(event.end)}</div>
                            <div className='mt-2 align-self-end'>
                                <button type="button" className="btn btn-primary" onClick={() => {
                                    props.history.push(links.interventoNew(undefined, event.start, event.end));
                                    modal.close();
                                }}>Ok</button>
                                <button type="button" className="btn btn-outline-secondary" data-dismiss="modal" onClick={modal.close}>Annulla</button>
                            </div>
                        </div>, "Nuovo intervento")
                    }}
                    eventClick={function (info) {
                        console.log(info);
                        const intervento = InterventiReportStore.get(info.event.id);
                        if (!intervento)
                            return;
                        if (intervento.idCliente)
                            props.history.push(links.interventoEdit(intervento.idCliente, intervento.idIntervento));
                        else
                            props.history.push(links.activityEdit(intervento.idIntervento));

                    }}
                    eventContent={
                        DayComponent ? ({ event }) => <DayComponent event={event} /> : undefined
                    }
                    events={async (arg, arg1, arg2) => {
                        let data = InterventiReportStore.getForPeriod(Period.Create(arg.start, arg.end));
                        if (!Array.isArray(data)) {
                            data = (await InterventiActions.getReportInterventi(arg.start, arg.end)).interventi;
                        }
                        if (data == null)
                            return [];

                        let interventi = allTechnicians != null && allTechnicians.length > 0
                            ? data
                                .filter(i => i.idTechnician == null || (state.technicians != null ? state.technicians : allTechnicians)
                                    .some(t => t.id === i.idTechnician))
                            : data;
                        return interventi
                            .map(i => ({
                                id: i.idIntervento.toString(),
                                title: `${i.oggettoIntervento} - ${i.dettaglioIntervento}`,
                                start: i.dataIntervento,
                                allDay: i.dataFineIntervento == null || i.dataIntervento.valueOf() == i.dataFineIntervento?.valueOf(),
                                end: i.dataFineIntervento ?? null,
                                backgroundColor: allTechnicians?.find(x => x.id == i.idTechnician)?.color ?? "var(--themecolor)",
                            } as EventInput));
                    }}
                    eventResize={data => {
                        const i = InterventiReportStore.get(data.event.id)!;
                        i.dataIntervento = DatesHelper
                            .Add(i.dataIntervento, {
                                days: data.startDelta.days,
                                months: data.startDelta.months,
                                years: data.startDelta.years,
                                milliseconds: data.startDelta.milliseconds,
                            })
                        if (i.dataFineIntervento)
                            i.dataFineIntervento = DatesHelper.Add(i.dataFineIntervento, {
                                days: data.endDelta.days,
                                months: data.endDelta.months,
                                years: data.endDelta.years,
                                milliseconds: data.endDelta.milliseconds,
                            })
                        InterventiActions
                            .update(i, i.idIntervento)
                            .catch(() => data.revert());
                    }}
                    eventDrop={dropData => {
                        const i = InterventiReportStore.get(dropData.event.id)!;
                        i.dataIntervento = DatesHelper.Add(i.dataIntervento, {
                            days: dropData.delta.days,
                            months: dropData.delta.months,
                            years: dropData.delta.years,
                            milliseconds: dropData.delta.milliseconds,
                        })
                        if (i.dataFineIntervento)
                            i.dataFineIntervento = DatesHelper.Add(i.dataFineIntervento, {
                                days: dropData.delta.days,
                                months: dropData.delta.months,
                                years: dropData.delta.years,
                                milliseconds: dropData.delta.milliseconds,
                            })
                        else {
                            i.dataFineIntervento = DatesHelper.Add(i.dataIntervento, {
                                milliseconds: 3600000,
                            })

                        }
                        InterventiActions
                            .update(i, i.idIntervento)
                            .catch(() => dropData.revert());
                    }}

                />
            </div >
        </div >
    )
}
